// extracted by mini-css-extract-plugin
export default {"root":"SwitchRender_root__+Qxec","icon":"SwitchRender_icon__9rP1p","title":"SwitchRender_title__BTcjE","item":"SwitchRender_item__Nl09r"};